<app-view-logs-table [data]="logDetailsData$ | async"></app-view-logs-table>
